@if (!isSwitching) {
    <h4 mat-dialog-title>{{ 'NAVBAR.CHANGE_TEAM' | translate }}</h4>
}

<mat-dialog-content>
    @if (!isSwitching) {
        <div>
            <div class="text-center">
                <div>Tvoje týmy</div>
                <ul class="list-group">
                    @for (team of teams; track team) {
                        <li
                            class="list-group-item"
                            [class.clickable]="team.id !== currentTeam"
                            [class.active]="team.id === currentTeam"
                            (click)="selectTeam(team)"
                        >
                            <div class="my-2">{{ team.name }}</div>
                        </li>
                    }
                </ul>
            </div>
            <ul class="list-group text-center mt-3">
                <li class="list-group-item bg-success clickable" (click)="createNewTeam()">
                    <div class="my-2"><i class="fas fa-user-plus"></i> {{ 'NAVBAR.CHANGE_TEAM_NEW_TEAM' | translate }}</div>
                </li>
            </ul>
        </div>
    }

    @if (isSwitching) {
        <div class="spinner d-flex flex-column align-items-center">
            <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
            <h4 class="mt-3">{{ 'NAVBAR.SWITCHING_TEAMS' | translate }}</h4>
        </div>
    }
</mat-dialog-content>
@if (!isSwitching) {
    <div mat-dialog-actions class="float-right">
        <button mat-button mat-dialog-close>{{ 'COMMON.CLOSE' | translate }}</button>
    </div>
}
